module.exports = __webpack_public_path__ + "img/characters_desktop_left.6767848f.png";